<template>
  <section id="firebaseui-auth-container" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import firebase from "firebase/app";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

export default defineComponent({
  name: "FirebaseUI",
  props: {
    redirectUrl: {
      type: String,
      required: true
    }
  },
  mounted() {
    const ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth());
    const uiConfig = {
      signInSuccessUrl: this.redirectUrl,
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    };
    ui.start("#firebaseui-auth-container", uiConfig);
  }
});
</script>

<style scoped>
ul.firebaseui-idp-list /deep/ {
  padding-left: 0 !important;
}
</style>
